import { Directive, HostListener, Input, Output } from '@angular/core';


/**
 * Adiciona outputs e inputs para facilitar desenvolvimenton, testes manuais e debug em geral.
 */
@Directive({
  selector: '[_debugger]'
})
export class DebuggerDirective {

  @Input() _log?: any


  @HostListener('click', ['$event.target'])
  onClick(btn: any) {
  }

}
